import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const { exchangeSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    
    // Parse Google OAuth code from search parameters
    const searchParams = new URLSearchParams(location.search || window.location.search);
    const code = searchParams.get('code');

    // Parse Emergent session_id from hash parameters
    const hash = location.hash || window.location.hash;
    const hashParams = new URLSearchParams(hash.replace(/^#/, ''));
    const sid = hashParams.get('session_id');

    if (!sid && !code) { navigate('/', { replace: true }); return; }

    exchangeSession(sid, code)
      .then((u) => {
        toast.success(`Welcome, ${u.name?.split(' ')[0] || 'friend'}!`);
        navigate('/', { replace: true });
      })
      .catch(() => {
        toast.error('Sign in failed, please try again.');
        navigate('/', { replace: true });
      });
  }, []);  // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center bg-bgmain">
      <div className="text-center">
        <Loader2 className="w-10 h-10 text-saffron animate-spin mx-auto mb-3" />
        <p className="font-body text-textsecondary">Signing you in...</p>
      </div>
    </div>
  );
}
